import Vue from 'vue'

Vue.prototype.$isBuyer = true
Vue.prototype.$isSeller = false

require('../src/main')
